export var createRenderer = function () {
    return function (options) {
        if (options && options.configuration.loadOnEvent) {
            var onBssConnectorInit = function () {
                this.init(options);
            };
            document.addEventListener(options.configuration.loadOnEvent, onBssConnectorInit);
        }
        else {
            return this.init(options);
        }
    };
};
